module.exports = __webpack_public_path__ + "static/assets/81c3f089e2bbf4a77c411d1723d92b21.svg";